import { INetwork, IToken } from '@/types'

import { create } from 'zustand'

export type SetWalletModalParams = {
  show: boolean
  token?: IToken | null
  source?: string | null
  connectedCallback?: () => void
  network?: INetwork | null
}
interface WalletModalState {
  showWalletModal: boolean
  currentToken?: IToken | null
  connectSource?: string | null
  network?: INetwork | null
  connectedCallback?: () => void

  actions: {
    setShowWalletModal: (params: SetWalletModalParams) => void
    handleWalletConnected: () => void
  }
  // Actions
}
const initialState = {
  showWalletModal: false,
  currentToken: undefined,
  connectSource: undefined,
  network: null,
  connectedCallback: undefined,
}
export const useWalletModal = create<WalletModalState>((set) => ({
  ...initialState,
  actions: {
    setShowWalletModal: ({ show, token, source, connectedCallback, network }: SetWalletModalParams) => {
      if (show) {
        set({
          showWalletModal: show,
          currentToken: token,
          connectSource: source,
          connectedCallback,
          network,
        })
      } else {
        set(initialState)
      }
    },
    handleWalletConnected: () => {
      set(initialState)
    },
  },
}))
export const useWalletModalActions = () => useWalletModal((state) => state.actions)
export const useShowWalletModal = () => useWalletModal((state) => state.showWalletModal)
export const useCurrentToken = () => useWalletModal((state) => state.currentToken)
export const useConnectSource = () => useWalletModal((state) => state.connectSource)
export const useNetwork = () => useWalletModal((state) => state.network)
export const useConnectedCallback = () => useWalletModal((state) => state.connectedCallback)
